import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'Cube/domain/cube.domain.types'

export const getUnlinkSalesforceCustomerAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (!prevState.data.common.customerId) {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.NoCustomerSelected,
          metadata: {}
        }
      ]
    }
  }

  if (prevState.data.quote.salesforceOpportunityId) {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.SalesforceOpportunityLinked,
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
